import React from 'react';
import { PLAYER_ACHIEVEMENT_CATEGORIES, achievements } from '../data/achievements';
import '../scss/awards.scss';

const AchievementCoin = ({ achievementId, isAchieved = true, size = 'medium', className = '' }) => {
    // Find the achievement data from both PLAYER_ACHIEVEMENT_CATEGORIES and achievements
    let achievementData = null;
    
    // First check in PLAYER_ACHIEVEMENT_CATEGORIES
    for (const category of Object.values(PLAYER_ACHIEVEMENT_CATEGORIES)) {
        const found = category.find(achievement => achievement.id === achievementId);
        if (found) {
            achievementData = found;
            break;
        }
    }
    
    // If not found in categories, check in main achievements array
    if (!achievementData) {
        achievementData = achievements.find(achievement => achievement.id === achievementId);
    }
    
    // If not found, return null or a placeholder
    if (!achievementData) {
        console.warn(`Achievement with ID "${achievementId}" not found`);
        return null;
    }
    
    const sizeClasses = {
        small: 'coin-small',
        medium: 'coin-medium', 
        large: 'coin-large'
    };
    
    return (
        <div 
            className={`award-card ${isAchieved ? 'achieved' : 'locked'} ${sizeClasses[size]} ${className}`}
            title={`${achievementData.title} - ${achievementData.description}`}
        >
            <div className="coin-content">
                <div className="award-icon">
                    {achievementData.icon}
                </div>
            </div>
        </div>
    );
};

export default AchievementCoin; 